export enum RentChargeActions {
  CreateRentCharge = 'rentCharge:CreateRentCharge',
  ListRentCharge = 'rentCharge:ListRentCharge',
}

export enum RentPaymentActions {
  ViewRentPaymentsPlan = 'rentPaymentsPlan:ViewRentPaymentsPlan',
}
